import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { userReducer } from './userReducer';
import { roleReducer } from './roleReducer';
import { auditlogReducer } from './auditlogReducer';
import { controllerReducer } from './controllerReducer';
import { equipmentsReducer } from './equipmentsReducer';
import { manufactureUnitReducer } from './manufactureUnitReducer';
import { inventoryReducer } from './inventoryReducer';
import { customerManagementReducer } from './customerManagementReducer';
import { dealerReducer } from './dealerReducer';
import { globalAlertReducer } from './globalAlertReducer';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  role: roleReducer,
  auditlog: auditlogReducer,
  controller: controllerReducer,
  equipments: equipmentsReducer,
  manufactureUnit: manufactureUnitReducer,
  inventory: inventoryReducer,
  customerManagement: customerManagementReducer,
  dealer: dealerReducer,
  globalAlert: globalAlertReducer,
});
